import React from "react";
import PictureInPictureIcon from '@mui/icons-material/PictureInPicture';

//Types
import { SvgIconProps } from "@mui/material";

function ZemljovidIcon(props: SvgIconProps) {
  return <PictureInPictureIcon {...props}/>;
}

export default ZemljovidIcon;
